// extracted by mini-css-extract-plugin
export default {"Chart":"chart_Chart__1s9dI","socialIcons":"chart_socialIcons__E3tk3"};